// El visor del lienzo, prestado a las cards del chat —
// ADR-2026-09-18-la-foto-del-chat-se-abre-en-el-visor-del-lienzo.
//
// Con el lienzo a la vista (el del Agente o el de un diseño), tocar una imagen en una
// card del chat abre el visor del lienzo (la vista expandida) en vez de navegar a la
// galería de imágenes generadas. El lienzo registra su `abrir` mientras está montado y lo
// retira al irse; las cards lo leen con `useVisorDelLienzo` y, si no hay ninguno, hacen
// lo de siempre. Es un módulo suelto y no un contexto: el lienzo y el panel del chat son
// hermanos (ninguno envuelve al otro) y `chat-atlas` no puede importar de vuelta desde
// `pages/v2` sin cerrar un ciclo (`sinCiclos.test.ts`).

import { useSyncExternalStore } from 'react';

export type VisorDelLienzo = (imageId: string) => void;

let visor: VisorDelLienzo | null = null;
const oyentes = new Set<() => void>();

export function registrarVisorDelLienzo(v: VisorDelLienzo | null): void {
  if (visor === v) return;
  visor = v;
  for (const o of oyentes) o();
}

export const leerVisorDelLienzo = (): VisorDelLienzo | null => visor;

export function suscribirVisorDelLienzo(o: () => void): () => void {
  oyentes.add(o);
  return () => {
    oyentes.delete(o);
  };
}

/** El visor del lienzo montado ahora, o `null` si no hay lienzo a la vista. */
export function useVisorDelLienzo(): VisorDelLienzo | null {
  return useSyncExternalStore(suscribirVisorDelLienzo, leerVisorDelLienzo, () => null);
}
